import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace
} from 'react-router-redux';
import {
  Button, Container, Divider,
  Form, Header, Icon, List,
  Menu, Modal, Segment, Statistic
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { range } from 'lodash';
import queryString from 'query-string';
import moment from 'moment';
import feathersConnect from './../../../providers/feathersConnect';
import NavPages from './../../navigation/NavPages';
import ItemList from './../../lists/ItemList';

const PAGE_RANGE = 10;
const INITIAL_STATE = {
  searchForm: {
    loading: false,
    values: {
      situacion: '',
      departamento: '',
      rubro: '',
      sector: '',
      asambleas: false,
      asambleasDesde: moment().format('YYYY-MM-DD'),
      docPreAsamblea: false,
      docPosAsamblea: false,
      docINAES: false,
      eeconomicoFilter: '',
      poseeCUIT: 0
    },
    error: null
  },
  departamentos: {
    loading: false,
    records: [],
    error: null
  },
  rubros: {
    loading: false,
    records: [],
    error: null
  },
  sectores: {
    loading: false,
    records: [],
    error: null
  },
  cooperativas: {
    records: [],
    ids: [],
    total: 0,
    limit: 10,
    offset: 0
  }
};
const baseOption = [
  {
    key: 99999,
    text: 'TODOS',
    value: ''
  }
];
const situacionOptions = [
  {
    key: 0,
    text: 'TODAS',
    value: ''
  },
  {
    key: 1,
    text: 'ACTIVA',
    value: 'ACTIVA'
  },
  {
    key: 2,
    text: 'SUSPENDIDA',
    value: 'SUSPENDIDA'
  },
  {
    key: 3,
    text: 'CANCELADA',
    value: 'CANCELADA'
  },
  {
    key: 4,
    text: 'CON RETIRO',
    value: 'CON RETIRO'
  },
  {
    key: 5,
    text: 'EN FORMACION',
    value: 'EN FORMACION'
  }
];

const currentYear = moment().year();

const yearOptions = [{ key: 0, text: 'NINGUNO', value: '' }].concat(range(100).map(i => ({
  key: i + 1,
  text: (currentYear - i).toString(),
  value: (currentYear - i).toString()
})));

const cuitOptions = [
  {
    key: 0,
    text: 'TODAS',
    value: 0
  },
  {
    key: 1,
    text: 'CON CUIT',
    value: 1
  },
  {
    key: 2,
    text: 'SIN CUIT',
    value: 2
  }
];

class InformeAvanzadoView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
    this.DepartamentoService = this.props.feathers.service('/api/departamentos');
    this.RubroService = this.props.feathers.service('/api/rubros');
    this.SectorService = this.props.feathers.service('/api/sectores');
    this.BusquedaService = this.props.feathers.service('/api/busqueda-informe-avanzado');
  }

  createInputHandler (name, type = 'input') {
    return (e, input) => {
      let valueSelector = {
        input: () => {
          return e.target.value;
        },
        select: () => {
          return input.value;
        },
        checkbox: () => {
          return !this.state.searchForm.values[name];
        }
      };

      this.changeFormValue(name, valueSelector[type]());
    };
  }

  changeFormValue (name, value) {
    let {
      searchForm
    } = this.state;

    this.setState({
      searchForm: {
        ...searchForm,
        values: {
          ...searchForm.values,
          [name]: value
        }
      }
    }, () => {
      if (name === 'rubro') {
        if (value) {
          this.findSectores(value);
        } else {
          this.setState({
            searchForm: {
              ...this.state.searchForm,
              values: {
                ...this.state.searchForm.values,
                sector: ''
              }
            }
          });
        }
      }
    });
  }

  findDepartamentos () {
    this.setState({
      departamentos: {
        ...this.state.departamentos,
        loading: true
      }
    });

    this.DepartamentoService.find({
      query: {
        skip: 0,
        limit: 9999
      }
    })
      .then(response => {
        this.setState({
          departamentos: {
            ...this.state.departamentos,
            loading: false,
            records: response.records
          }
        });
      })
      .catch(error => {
        this.setState({
          departamentos: {
            ...this.state.departamentos,
            loading: false,
            error
          }
        });
      });
  }

  findRubros () {
    this.setState({
      rubros: {
        ...this.state.rubros,
        loading: true
      }
    });

    this.RubroService.find({
      query: {
        skip: 0,
        limit: 9999
      }
    })
      .then(response => {
        this.setState({
          rubros: {
            ...this.state.rubros,
            loading: false,
            records: response.records
          }
        });
      })
      .catch(error => {
        this.setState({
          rubros: {
            ...this.state.rubros,
            loading: false,
            error
          }
        });
      });
  }

  findSectores (rubroId) {
    this.setState({
      sectores: {
        ...this.state.sectores,
        loading: true
      }
    });

    this.SectorService.find({
      query: {
        rubroId,
        skip: 0,
        limit: 9999
      }
    })
      .then(response => {
        this.setState({
          sectores: {
            ...this.state.sectores,
            loading: false,
            records: response.records
          }
        });
      })
      .catch(error => {
        this.setState({
          sectores: {
            ...this.state.sectores,
            loading: false,
            error
          }
        });
      });
  }

  findCooperativas () {
    let {
      cooperativas: {
        offset,
        limit
      },
      searchForm: {
        values
      }
    } = this.state;

    this.setState({
      searchForm: {
        ...this.state.searchForm,
        loading: true,
        error: null
      },
      cooperativas: {
        ...this.state.cooperativas,
        records: []
      }
    });

    this.BusquedaService.find({
      query: {
        ...values,
        skip: offset,
        limit: limit
      }
    })
      .then(response => {
        this.setState({
          searchForm: {
            ...this.state.searchForm,
            loading: false
          },
          cooperativas: {
            ...this.state.cooperativas,
            ...response
          }
        });
      })
      .catch(error => {
        this.setState({
          searchForm: {
            ...this.state.searchForm,
            loading: false,
            error
          }
        });
      });
  }

  submitSearch (e) {
    e.preventDefault();

    this.findCooperativas();
  }

  pageChange (page) {
    let limit = PAGE_RANGE;
    let offset = page * PAGE_RANGE;

    this.setState({
      cooperativas: {
        ...this.state.cooperativas,
        offset,
        limit
      }
    }, () => {
      this.findCooperativas();
    });
  }

  mapDepartamentosToOptionsList = (departamentos) => departamentos.map((dpto, index) => ({
    key: index,
    text: dpto.nombre,
    value: dpto.id
  }))

  mapRubrosToOptionsList = (rubros) => rubros.map((rubro, index) => ({
    key: index,
    text: rubro.nombre,
    value: rubro.id
  }))

  mapSectoresToOptionsList = (sectores) => sectores.map((sector, index) => ({
    key: index,
    text: sector.nombre,
    value: sector.id
  }))

  mapCooperativaToItemList = (cooperativas) => cooperativas.map((cooperativa) => ({
    id: cooperativa.id,
    header: cooperativa.nombre,
    description: `MN: ${cooperativa.matriculaNacional} MP: ${cooperativa.matriculaProvincial} CUIT: ${cooperativa.cuit}`
  }))

  selectCooperativa (cooperativa) {
    window.open(`/reporte?type=matricula&id=${cooperativa.id}`);
    // this.props.navigate(`/reporte?type=matricula&id=${cooperativa.id}`);
  }

  linkToReport () {
    let {
      searchForm: {
        values
      }
    } = this.state;

    window.open(`/reporte-avanzado?${queryString.stringify(values)}`);
  }

  linkToReportEconomico () {
    let {
      searchForm: {
        values
      }
    } = this.state;

    window.open(`/reporte-economico?${queryString.stringify(values)}`);
  }

  componentDidMount () {
    this.findDepartamentos();
    this.findRubros();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      departamentos,
      rubros,
      sectores,
      cooperativas,
      searchForm
    } = this.state;

    return (
      <div>
        <Form loading={searchForm.loading} onSubmit={this.submitSearch.bind(this)}>
          <Form.Group widths="equal">
            <Form.Select
              label="Situacion"
              options={situacionOptions}
              value={searchForm.values.situacion}
              onChange={this.createInputHandler('situacion', 'select')} />
            <Form.Select
              label="Departamento"
              loading={departamentos.loading}
              options={baseOption.concat(this.mapDepartamentosToOptionsList(departamentos.records))}
              value={searchForm.values.departamento}
              onChange={this.createInputHandler('departamento', 'select')} />
            <Form.Select
              label="Rubro"
              loading={rubros.loading}
              options={baseOption.concat(this.mapRubrosToOptionsList(rubros.records))}
              value={searchForm.values.rubro}
              onChange={this.createInputHandler('rubro', 'select')} />
            <Form.Select
              label="Sector"
              loading={sectores.loading}
              disabled={!searchForm.values.rubro}
              options={baseOption.concat(this.mapSectoresToOptionsList(sectores.records))}
              value={searchForm.values.matriculaProvincial}
              onChange={this.createInputHandler('sector', 'select')} />
          </Form.Group>
          <Form.Group>
            <Form.Checkbox
              label="Realizaron Asambleas" checked={searchForm.values.asambleas}
              onChange={this.createInputHandler('asambleas', 'checkbox')} />
            <Form.Checkbox
              label="Documentacion PRE Asamblea" checked={searchForm.values.docPreAsamblea}
              onChange={this.createInputHandler('docPreAsamblea', 'checkbox')} />
            <Form.Checkbox
              label="Documentacion POS Asamblea" checked={searchForm.values.docPosAsamblea}
              onChange={this.createInputHandler('docPosAsamblea', 'checkbox')} />
            <Form.Checkbox
              label="Documentacion INAES" checked={searchForm.values.docINAES}
              onChange={this.createInputHandler('docINAES', 'checkbox')} />
          </Form.Group>
          {
            searchForm.values.asambleas &&
            <Form.Group>
              <Form.Input
                label="Fecha Asamblea (Desde)" type="date" value={searchForm.values.asambleasDesde}
                onChange={this.createInputHandler('asambleasDesde', 'input')} />
            </Form.Group>
          }
          <Form.Group>
            <Form.Select
              label="E.Economico con cierre en" options={yearOptions} search
              value={searchForm.values.eeconomicoFilter}
              onChange={this.createInputHandler('eeconomicoFilter', 'select')} />
            <Form.Select
              label="CUIT" options={cuitOptions} search
              value={searchForm.values.poseeCUIT}
              onChange={this.createInputHandler('poseeCUIT', 'select')} />
          </Form.Group>
          <Form.Group>
            <Button
              type="submit" disabled={searchForm.loading}
              content={searchForm.loading ? 'Cargando...' : 'Buscar'} icon="search" />
            <Button
              type="button" disabled={searchForm.loading || !cooperativas.records.length}
              content="Generar Reporte" icon="book" onClick={this.linkToReport.bind(this)} />
            <Button
              type="button" disabled={searchForm.loading || !cooperativas.records.length || !cooperativas.records.every(c => c.eeconomicos)}
              content="Generar Reporte Economico" icon="book" onClick={this.linkToReportEconomico.bind(this)} />
          </Form.Group>
        </Form>
        <Divider />
        <ItemList data={this.mapCooperativaToItemList(cooperativas.records)} loading={searchForm.loading} selectItem={this.selectCooperativa.bind(this)} />
        <Segment vertical clearing>
          <Statistic horizontal size="mini">
            <Statistic.Value>{cooperativas.total}</Statistic.Value>
            <Statistic.Label>Registros</Statistic.Label>
          </Statistic>
          {
            !searchForm.loading &&
              <NavPages
                floated="right" pageChange={this.pageChange.bind(this)}
                selected={cooperativas.offset / PAGE_RANGE} itemsPerPage={PAGE_RANGE} total={cooperativas.total} />
          }
        </Segment>
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    InformeAvanzadoView.mapStateToProps,
    InformeAvanzadoView.mapDispatchToProps
  )(InformeAvanzadoView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/InformeAvanzadoView.js